import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackBookingClick } from './tracking/newbuildingBooking';
import { openNewbuildingBookedFromDeveloperConfirmAction } from '../../actions/newbuildingBookedFromDeveloper';
import { NewbuildingBookedFromDeveloperButton } from '../../components/NewbuildingBookedFromDeveloperButton';
import { getOfferCustomUrl } from '../../selectors/analytics';

interface INewbuildingBookedFromDeveloperButtonContainerProps {
  buttons?: React.ReactNode;
}

export const NewbuildingBookedFromDeveloperButtonContainer: React.FC<
  INewbuildingBookedFromDeveloperButtonContainerProps
> = ({ buttons }) => {
  const dispatch = useDispatch();
  const customUrl = useSelector(getOfferCustomUrl);

  const bookOffer = React.useCallback(() => {
    dispatch(openNewbuildingBookedFromDeveloperConfirmAction());
    trackBookingClick(customUrl);
  }, [dispatch, customUrl]);

  return <NewbuildingBookedFromDeveloperButton onClick={bookOffer} buttons={buttons} />;
};
